var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ElementRef } from '@angular/core';
import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { DwMessageContainerComponent } from 'ng-quicksilver';
import { NavigationEnd, Router } from '@angular/router';
import { ComponentPortal } from '@angular/cdk/portal';
import { TranslateService } from '@ngx-translate/core';
import { FxModalService } from 'app/implementation/shared/components/fx-modal/fx-modal.service';
/**
 * https://github.com/angular/angular/issues/20515
 * 子組件使用DwMessageService，報ExpressionChangedAfterItHasBeenCheckedError錯誤
 *
 * 因以上原因，先自己實作
 */
var DwRoutingMessageService = /** @class */ (function () {
    function DwRoutingMessageService(router, fxModalService, translateService, overlay) {
        var _this = this;
        this.router = router;
        this.fxModalService = fxModalService;
        this.translateService = translateService;
        this.overlay = overlay;
        this._counter = 0; // Id counter for messages
        this.routedMessages = [];
        this.messages = [];
        this._idPrefix = '';
        this.router.events
            .subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                _this._flushRoutedMessage();
            }
        });
    }
    DwRoutingMessageService.prototype.addToRoute = function (content) {
        this.routedMessages.push(content);
    };
    DwRoutingMessageService.prototype.add = function (content) {
        this.messages.push(content);
    };
    DwRoutingMessageService.prototype._flushRoutedMessage = function () {
        if (this.routedMessages.length > 0) {
            var html = this.routedMessages.join('<br/>');
            this.routedMessages.splice(0);
            this.send(html);
        }
        return {};
    };
    DwRoutingMessageService.prototype.flush = function (options) {
        if (this.messages.length > 0) {
            var html = this.messages.join('<br/>');
            this.messages.splice(0);
            return this.html(html, options);
        }
        return {};
    };
    // Shortcut methods
    DwRoutingMessageService.prototype.success = function (content, options) {
        return this.createMessage({ type: 'success', content: content }, options);
    };
    DwRoutingMessageService.prototype.error = function (content, options) {
        return this.createMessage({ type: 'error', content: content }, options);
    };
    DwRoutingMessageService.prototype.info = function (content, options) {
        return this.createMessage({ type: 'info', content: content }, options);
    };
    DwRoutingMessageService.prototype.warning = function (content, options) {
        return this.createMessage({ type: 'warning', content: content }, options);
    };
    DwRoutingMessageService.prototype.errorNew = function (content1, content2, content3, content4, options) {
        var returing;
        if (content2 == "2") {
            this.fxModalService.confirm({ title: this.translateService.instant('com-Message'), message: content1 + "\n", programNo: content3, programName: content4, isRemind: true });
            returing = "";
        }
        else if (content2 == "3") {
            this.fxModalService.confirm({ title: this.translateService.instant('com-Message'), message: content1 + "\n", programNo: content3, programName: content4, isRemind: false });
            returing = "";
        }
        else if (content2 == "4") {
            returing = content1;
        }
        else {
            this.warning(content1);
            returing = "";
        }
        return returing;
    };
    DwRoutingMessageService.prototype.loading = function (content, options) {
        return this.createMessage({ type: 'loading', content: content }, options);
    };
    DwRoutingMessageService.prototype.create = function (type, content, options) {
        return this.createMessage({ type: type, content: content }, options);
    };
    /**   以下為實驗性質，搭配<dw-message-holder></dw-message-holder>使用 **/
    DwRoutingMessageService.prototype.html = function (html, options) {
        return this.createMessage({ html: html }, options);
    };
    DwRoutingMessageService.prototype.send = function (content) {
        this.createMessage({ content: content });
    };
    // 相對於elementRef的位置。但nz自己的.ant-message CSS位置要修正
    DwRoutingMessageService.prototype.setHost = function (elementRef) {
        this._setHost(elementRef);
    };
    DwRoutingMessageService.prototype.createMessage = function (message, options) {
        if (!this._container) {
            this._setHost();
        }
        var resultMessage = __assign({}, message, {
            messageId: this._generateMessageId(),
            options: options,
            createdAt: new Date()
        });
        this._container.createMessage(resultMessage);
        return resultMessage;
    };
    DwRoutingMessageService.prototype._setHost = function (elementRef) {
        var positionStrategy;
        if (elementRef) {
            positionStrategy = this.overlay.position().connectedTo(elementRef, { originX: 'start', originY: 'bottom' }, { overlayX: 'end', overlayY: 'top' });
        }
        else {
            positionStrategy = this.overlay.position().global();
        }
        var overlayRef = this.overlay.create(new OverlayConfig({
            positionStrategy: positionStrategy
        }));
        this._container = overlayRef.attach(new ComponentPortal(DwMessageContainerComponent)).instance;
    };
    DwRoutingMessageService.prototype._generateMessageId = function () {
        return this._idPrefix + this._counter++;
    };
    return DwRoutingMessageService;
}());
export { DwRoutingMessageService };
